import { defineStore } from "pinia";

export const useContextMenuStore = defineStore("contextMenu", {
  state: () => ({
    options: [],
    isVisible: false,
    position: { x: 0, y: 0 },
    temporaryOptions: [],
  }),

  actions: {
    setOptions(options) {
      this.options = options;
    },
    addOption(option) {
      if (Array.isArray(option)) {
        this.options = [...option];
      } else {
        this.options.push(option);
      }
    },
    reset() {
      this.options = [];
      this.temporaryOptions = [];
      this.isVisible = false;
    },
    showMenu(options, event = null) {
      // If an event is provided, position the menu at the event coordinates
      if (event) {
        this.position = {
          x: event.clientX,
          y: event.clientY,
        };
      }

      // Set temporary options specific to this menu instance
      this.temporaryOptions = options;
      this.isVisible = true;
    },
    hideMenu() {
      this.isVisible = false;
      this.temporaryOptions = [];
    },
    executeAction(action) {
      if (typeof action === "function") {
        action();
      }
      this.hideMenu();
    },
  },
});
